import React, {useEffect, useState} from 'react';
import ExplorerFundListingModalView from "./ExplorerFundListingModalView";
import {connect} from "react-redux";
import {getFundSummary, setFundList} from "../../fund/FundAction";
import {explorerConst} from "../ExplorerConsts";
import {setFundsKeywordFilter} from "../ExplorerAction";
import {isEmpty} from "../../utils/validations";
import {searchOnWordBoundary} from "../../utils/helper";
import {getListingData} from "../../utils/stocksHelper";
import {advanceSearchConst} from "../../AdvanceSearch/AdvanceSearchConst";
import {setAllFundsData} from "../../fund/FundReducer";
import {setAdvanceKeywordFilter} from "../../AdvanceSearch/AdvanceSeachAction";

function ExplorerFundListingModal(props) {

    const{isExternalFundSelected, externalFundData, setFilter, isFundModalOpen, externalFundStocksKeyword} = props;
    const [advanceFundListingModalState, setAdvanceFundListingModalState] = useState({
        modalUIState: '',
        sortedData: [],
        previousFundListing: [],
        skipCount: 0,
        limitCount : 60
    });


    useEffect(()=>{
        const {skipCount, limitCount} = advanceFundListingModalState;
        if (isExternalFundSelected || isFundModalOpen ){
            if (!isEmpty(props.fundListingData)){
                // handleListingOptions();
                setAdvanceFundListingModalState((prev) => ({
                    ...prev,
                    modalUIState: advanceSearchConst.CONTENT_AVAILABLE,
                    previousFundListing: props.fundListingData
                }));
            }
            else {
                getFundSummary(props.currentMonthDate, skipCount, limitCount).then((res) => {
                    if (res?.statusCode === 200 || res?.statusCode === 201) {
                        let data = getListingData(res.data.data, 'fund_name');

                        data = handleExternalCheckChange(externalFundData, data);
                        setFundList(data);
                        applyExternalFilter(data);

                        setAdvanceFundListingModalState((prev) => ({
                            ...prev,
                            modalUIState: advanceSearchConst.CONTENT_AVAILABLE
                        }));

                    } else {
                        setAdvanceFundListingModalState((prev) => ({
                            ...prev,
                            modalUIState: advanceSearchConst.CONTENT_UNAVAILABLE
                        }));
                    }
                })
            }
        }
    },[isFundModalOpen, isExternalFundSelected]);

    useEffect(()=>{
        const {fundsKeyword, isMobileView, isXSView} = props;
        const {fundListingData} = props;

        if (isEmpty(fundListingData)){
            return
        }

        if (isEmpty(fundsKeyword)){
            setFundList(fundListingData);

            // props.onChangeValue('fundListingData', fundListingData);

            setAdvanceFundListingModalState((prev)=>({
                ...prev,
                sortedData: [],
                searchResultNotAvailable: false
            }));
        }else {
            let sortedData = [];
            setAdvanceFundListingModalState((prev)=>({
                ...prev,
                isSearchApply: true
            }));

            let options =  fundListingData.map((item)=>{
                return {...item, label:item.fund_name, value: item.fund_name}
            });

            sortedData = searchOnWordBoundary(props.fundsKeyword, JSON.parse(JSON.stringify(options)));

            if (!isEmpty(sortedData)){

                setAdvanceFundListingModalState((prev)=>({
                    ...prev,
                    sortedData: sortedData,
                    searchResultNotAvailable: false
                }));
            }else {
                setAdvanceFundListingModalState((prev)=>({
                    ...prev,
                    sortedData: [],
                    searchResultNotAvailable: true
                }));
            }

            setTimeout(()=>{
                setAdvanceFundListingModalState((prev)=>({
                    ...prev,
                    isSearchApply: false
                }))
            },300)

        }

    },[props.fundsKeyword]);

    const handleListingOptions = () => {
        const {fundHouses} = props.explorerFilter;
        const {allFundsData} = props;
        let selectedValues = checkSelectedValues();

        let filteredFunds = [];
        if (!isEmpty(fundHouses)) {
            fundHouses.forEach((item) => {
                allFundsData.forEach((obj) => {
                    if (item === obj?.fund_house_id) {
                        filteredFunds.push(obj)
                    }
                })
            })
        }else{
            filteredFunds = allFundsData
        }
        let addedArray = [...filteredFunds, ...selectedValues];

        selectedValues.forEach((item) => {
            addedArray.forEach((obj, index) => {
                if ((item?.fund_id === obj?.fund_id) && (item?.fund_house_id === obj?.fund_house_id) && (!obj?.isSelected)) {
                    addedArray.splice(index,1)
                }
            })
        });
        setFundList(addedArray);
        applyExternalFilter(addedArray)
    };

    const handlePreviousDataChange = (previousData, selectedFund) => {

        if (isEmpty(selectedFund)){
            return previousData
        }
        console.log('selectedFund', typeof selectedFund);

        return previousData.map(item => ({
            ...item,
            isSelected: selectedFund.some(obj2 => (obj2.fund_house_id === item.fund_house_id) && (obj2.fund_id === item.fund_id) ),
        }));
    };

    const handleExternalCheckChange = (value, data) => {
        let updatedArray;
        const{isFrom} = props;
        const {fundHouses} = props.explorerFilter;
        if (isEmpty(value)) {
            if (!isEmpty(fundHouses)) {
                let filteredFunds = [];
                fundHouses.forEach((item) => {
                    data.forEach((obj) => {
                        if (item === obj.fund_house_id) {
                            filteredFunds.push(obj)
                        }
                    })
                });

                return filteredFunds;
            } else {
                return data
            }
        }
        if(!isEmpty(externalFundStocksKeyword)){
            setAdvanceKeywordFilter(externalFundStocksKeyword)
        }
        if(isFrom === "watchlist"){
            updatedArray = data.map(item => {
                const isMatch = value.some(v => v.fund_house_id === item.fund_house_id && v.fund_id === item.fund_id);
                if (isMatch) {
                    return { ...item, isSelected: !item.isSelected };
                }
                return item;
            });
            return updatedArray;
        }

        if (Array.isArray(value)){
            let newArray = data.map(item => ({
                ...item,
                isSelected: value.some(obj2 => obj2.fund_house_id === item.fund_house_id && obj2.fund_id === item.fund_id),
            }));

            return  newArray
        }

         updatedArray = data.map(item => {
            if (item.fund_house_id === value.fund_house_id && item.fund_id === value.fund_id) {
                return { ...item, isSelected: !item.isSelected };
            }

            // Return the original object if the id doesn't match
            return item;
        });
        return updatedArray
    };

    const updateFundData = (data) => {
        let updatedArray;
        const {fundHouses, funds, fundHousesForFund} = props.explorerFilter;

        updatedArray = data.map(item => {
            if (funds.includes(item.fund_id)) {
                return {...item, isSelected: true};
            }
            return item;
        });
        return updatedArray
    };

    const applyExternalFilter = (data) => {
        let selectedValues = checkExternalSelectedValues(data);
        setFilter('funds', selectedValues, 'fund_id');
        props.history.replace();
    };

    const handleCheckboxChange = (value) => {
        const {fundListingData} = props;

        const updatedArray = fundListingData.map(item => {
            if (item.fund_house_id === value.fund_house_id && item.fund_id === value.fund_id) {
                return { ...item, isSelected: !item.isSelected };
            }

            // Return the original object if the id doesn't match
            return item;
        });
        setFundList(updatedArray);

        // props.onChangeValue('fundListingData', updatedArray);

    };

    const clearSelectedFunds = (value) => {
        const {fundListingData} = props;

        const updatedArray = fundListingData.map(item => {
            return { ...item, isSelected: false };
        });
        setFundList(updatedArray);

        // props.onChangeValue('fundListingData', updatedArray);

    };

    const checkboxChange = (value) => {
        const {fundListingData} = props;
        // console.log('updatedArray[index]', !value)

        // Make a copy of the object at the specified index
        const updatedItem = fundListingData.find(item =>  (item.fund_house_id === value.fund_house_id && item.fund_id === value.fund_id));

        return updatedItem?.isSelected
    };

    const onChangeKeywordFilter = (fundsKeyword) => {
        setFundsKeywordFilter(fundsKeyword)
    };

    const checkExternalSelectedValues = (data) => {
        const {fundListingData} = props;
        return  data.filter((item)=>item.isSelected);
    };

    const checkSelectedValues = () => {
        const {fundListingData} = props;
        return  fundListingData.filter((item)=>item.isSelected);
    };

    return (
        <ExplorerFundListingModalView {...advanceFundListingModalState}
                                      {...props}
                                      handleCheckboxChange={handleCheckboxChange}
                                      checkboxChange={checkboxChange}
                                      checkSelectedValues={checkSelectedValues}
                                      clearSelectedFunds={clearSelectedFunds}
                                      onChangeKeywordFilter={onChangeKeywordFilter}/>
    )
}

const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    currentMonthDate: state.userState.currentMonthDate,
    isMDView: state.appState.deviceInfo.isMDView,
    isLGView: state.appState.deviceInfo.isLGView,
    isXLView: state.appState.deviceInfo.isXLView,
    isSMView: state.appState.deviceInfo.isSMView,
    isXSView: state.appState.deviceInfo.isXSView,
    fundsData: state.fundState.fundsData,
    fundsLoaded: state.fundState.fundsLoaded,
    fundsKeyword: state.ExplorerState.fundsKeyword,
    allFundsData: state.fundState.allFundsData,
});

export default connect(mapStateToProps, {
    setAllFundsData
})(ExplorerFundListingModal);